/**
 * enum for user roles in the system
 */
export enum UserRolesIdsEnum {
  OR_RESEARCHER = 'OR_RESEARCHER',
  OR_STUDY_ADMIN = 'OR_STUDY_ADMIN',
  RDM_ANNOTATION_SUPERVISOR = 'RDM_ANNOTATION_SUPERVISOR',
  RDM_ANNOTATOR = 'RDM_ANNOTATOR',
  SA_ADMIN = 'SA_ADMIN',
  SA_ROOT = 'SA_ROOT',
  VRN_DATA_ADMIN = 'VRN_DATA_ADMIN',
  VRN_RESEARCH_PARTNER = 'VRN_RESEARCH_PARTNER',
  ANNOTATION_MANAGER = 'ANNOTATION_MANAGER',
  ANNOTATION_USER = 'ANNOTATION_USER',
  ACCURACY_VIEWER = 'ACCURACY_VIEWER',
}

/**
 * enum defining display name for user roles in the system
 */
export enum UserRolesDisplayNameEnum {
  Researcher = 'Researcher',
  System_administrator = 'System administrator',
  Study_administrator = 'Study administrator',
  Annotation_supervisor = 'Annotation supervisor',
  Annotator = 'Annotator',
  Root = 'Root user',
  Data_administrator = 'Data administrator',
  Research_partner = 'Research partner',
  Annotation_manager = 'Annotation manager',
  Annotation_user = 'Annotation user',
  Accuracy_viewer = 'Accuracy viewer',
}

export enum OrganizationTypeEnum {
  CUSTOMER = 'CUSTOMER',
  RESEARCH_PARTNER = 'RESEARCH_PARTNER',
  VERANTOS = 'VERANTOS',
}
